// extracted by mini-css-extract-plugin
module.exports = {"table":"PassportsAndSertificates_table__32zS0","container":"PassportsAndSertificates_container__3GR_l"};